module.exports = __webpack_public_path__ + "static/media/Sports-banner.a311a123.png";